import { Button, Flex } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { SummaryPolicy } from "../SummaryPolicy"

import type { SummarySectionProps } from "./SummarySection.types"

export const SummarySection = (props: SummarySectionProps) => {
  const { record, onClick, onViewDecisions } = props
  const { t } = useTranslation()
  const edit = <Button onClick={onClick}>Edit</Button>

  return (
    <Flex align="center" justify="space-between">
      <SummaryPolicy record={record} showEnforcement={!!onViewDecisions} />
      {onViewDecisions ? (
        <Flex align="center" gap={12}>
          <Button onClick={onViewDecisions}>
            {t("governance.ai.live.decisions.view")}
          </Button>
          {edit}
        </Flex>
      ) : (
        edit
      )}
    </Flex>
  )
}
